import React from 'react';

import { useMatchMedia } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';
import { Box, Card, Flex, Tag } from '@betterment/style-closet-react';

import { useReferralSenderOffer } from './ReferAFriendProvider';

import { getReferralSenderOffer } from '../utils';

const UnclaimedRewardCard: React.FC = () => {
  const { enabled: isCashReserveApyUpdateQ32025Enabled, loading: isFeatureFlagLoading } = useFeatureFlag({
    splitName: 'retail.refer_a_friend_rewards_card_updated_rate_q3_2025_enabled',
    context: 'UnclaimedRewardCard',
  });

  const { senderOfferName, hasMaximumInvestingReferrals } = useReferralSenderOffer();
  const isAtLeastMedium = useMatchMedia('atLeastMedium');

  if (senderOfferName == null || hasMaximumInvestingReferrals) return null;
  const { title, titleV2, description, additionalDescription, limitedTime, featuredImage } =
    getReferralSenderOffer(senderOfferName);

  return (
    <Card>
      <Card.Slot name="header">Your next referral reward</Card.Slot>
      <Card.Slot name="body">
        <Box>
          <Flex justifyContent="space-between" flexDirection={['column', 'row']}>
            <Box maxWidth={['none', '100px']} width="100%" m="0 auto">
              {isAtLeastMedium ? (
                <img src={featuredImage.image} alt={featuredImage.alt} width="100%" />
              ) : (
                <img src={featuredImage.mobile} alt={featuredImage.alt} width="100%" />
              )}
            </Box>

            <Box pl={['0', '6']} pt={['6', '0']}>
              {limitedTime && (
                <Tag size="small" bg="bmtBlue10" py="1" px="3" mb="3">
                  Limited Time
                </Tag>
              )}
              {!isFeatureFlagLoading && (
                <Text
                  as="p"
                  css={{
                    fontWeight: 'medium',
                    marginBottom: 'space.100',
                  }}
                >
                  {isCashReserveApyUpdateQ32025Enabled && titleV2 ? titleV2 : title}
                </Text>
              )}
              <Text as="p" color="text.weak" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
                {description} {additionalDescription}
              </Text>
            </Box>
          </Flex>
        </Box>
      </Card.Slot>
    </Card>
  );
};

export default UnclaimedRewardCard;
